import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftIssuerAutocompleteResponse } from '@/repositories/generated';

// 名称・IDは取引履歴一覧モック（src/mocks/api/transaction/transaction.ts）と整合させている
const giftIssuersByWalletService: Record<string, GiftIssuerAutocompleteResponse[]> = {
  '001': [
    { id: '1', name: 'くまもとデジタル推進協会' },
  ],
  '002': [
    { id: '3', name: 'ABI用商品券事業者1' },
  ],
};

const fallbackResponse: GiftIssuerAutocompleteResponse[] = [
  { id: '1', name: 'くまもとデジタル推進協会' },
  { id: '3', name: 'ABI用商品券事業者1' },
];

export const autocompleteGiftIssuer = http.get(
  createMockEndpoint('/autocomplete/gift_issuer'),
  async ({ request }) => {
    await delay(500);
    const url = new URL(request.url);
    const walletServiceId = url.searchParams.get('walletServiceId');
    const response = walletServiceId
      ? giftIssuersByWalletService[walletServiceId] ?? []
      : fallbackResponse;
    return HttpResponse.json(response, { status: 200 });
  },
);
